import axiosInstance from '../config/axios.js';

const API_BASE = '/inventory-usage';

const inventoryUsageService = {
  // Get all usage records with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get usage record by ID
  getById: async (usageId) => {
    const response = await axiosInstance.get(`${API_BASE}/${usageId}`);
    return response.data;
  },

  // Get usage records by inventory ID
  getByInventory: async (inventoryId) => {
    const response = await axiosInstance.get(`${API_BASE}/inventory/${inventoryId}`);
    return response.data;
  },

  // Get usage records by user ID
  getByUser: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/user/${userId}`);
    return response.data;
  },

  // Get usage records by vehicle ID
  getByVehicle: async (vehicleId) => {
    const response = await axiosInstance.get(`${API_BASE}/vehicle/${vehicleId}`);
    return response.data;
  },

  // Create new usage record
  create: async (usageData, returnReceipt = null) => {
    const formData = new FormData();
    
    // Append all usage data
    Object.keys(usageData).forEach(key => {
      if (usageData[key] !== null && usageData[key] !== undefined && usageData[key] !== '') {
        formData.append(key, usageData[key]);
      }
    });

    // Append file if provided
    if (returnReceipt) {
      formData.append('return_receipt', returnReceipt);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Update usage record
  update: async (usageId, usageData, returnReceipt = null) => {
    const formData = new FormData();
    
    // Append all usage data
    Object.keys(usageData).forEach(key => {
      if (usageData[key] !== null && usageData[key] !== undefined && usageData[key] !== '') {
        formData.append(key, usageData[key]);
      }
    });

    // Append file if provided
    if (returnReceipt) {
      formData.append('return_receipt', returnReceipt);
    }

    const response = await axiosInstance.put(`${API_BASE}/${usageId}`, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Delete usage record
  delete: async (usageId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${usageId}`);
    return response.data;
  },

  // Get usage types
  getUsageTypes: () => {
    return [
      { value: 'Consumption', label: 'Consumption' },
      { value: 'Allocation', label: 'Allocation' },
      { value: 'Transfer', label: 'Transfer' },
      { value: 'Return', label: 'Return' },
      { value: 'Maintenance', label: 'Maintenance' },
      { value: 'Damaged', label: 'Damaged' },
      { value: 'Lost', label: 'Lost' },
      { value: 'Adjustment', label: 'Adjustment' }
    ];
  },

  // Get usage purposes
  getUsagePurposes: () => {
    return [
      { value: 'Vehicle Maintenance', label: 'Vehicle Maintenance' },
      { value: 'Vehicle Repair', label: 'Vehicle Repair' },
      { value: 'Shipment Packaging', label: 'Shipment Packaging' },
      { value: 'Office Use', label: 'Office Use' },
      { value: 'Warehouse Operation', label: 'Warehouse Operation' },
      { value: 'Customer Delivery', label: 'Customer Delivery' },
      { value: 'Employee Use', label: 'Employee Use' },
      { value: 'Emergency Use', label: 'Emergency Use' },
      { value: 'Testing', label: 'Testing' },
      { value: 'Training', label: 'Training' },
      { value: 'Project Work', label: 'Project Work' },
      { value: 'Other', label: 'Other' }
    ];
  }
};

export default inventoryUsageService;